import { createContext } from 'react'
import { globalEventBus } from '../events'
import { setPlatformGlobals } from '../globals'

export const EventBusContext = createContext(globalEventBus)

// TODO: Remove this once everything is being consumed from HorizonContext
setPlatformGlobals({ EventBusContext })

export const EventBusContextProvider = EventBusContext.Provider
